<template>
  <div id="app" :class="[{'mobile' : isMobile, 'betslip' : BetSlip, 'modal' : !_.isEmpty(notify)}, activePanel, _.toLower($route.name)]">

    <notifications group="default" position="top right" :duration="3000" :speed="500" />
                   
    <MobilePanelLeft @triggerPanel="activePanel = $event" v-if="isMobile && routeLayout"/>
    <MobilePanelRight @triggerPanel="activePanel = $event" v-if="isMobile && $user()"/>

    <div class="center-block page-loader" id="loader" v-if="isLoading">
        <div class="loader-alternative">
            <div class="loader-2 center"><span></span></div>
        </div>
    </div>

    <div class="inc" v-if="!isLoading">
      <div v-show="activePanel != '' || BetSlip" @click="activePanel = ''" class="overlay"></div>
      <DomainInfo/>
      <Header :activePanel="activePanel" v-if="routeLayout" @triggerPanel="activePanel = $event"></Header>
      <div class="router">
        <!-- <keep-alive>
          <router-view v-if="$route.meta.KeepAlive"></router-view>
        </keep-alive>
        <router-view v-if="!$route.meta.KeepAlive"></router-view> -->
        <router-view></router-view>
      </div>
      <Footer v-if="routeLayout"></Footer>
      <MobileBottom v-if="isMobile && routeLayout"/>
      <div class="notify-modal">
        <Modal :isVisible="!_.isEmpty(notify)">
          <template slot="content">
            <button @click="closeNotify('notshow')" type="button" class="button secondary close">
              <svg xmlns="http://www.w3.org/2000/svg" width="512px" height="512px" viewBox="0 0 512 512"><path d="M289.94,256l95-95A24,24,0,0,0,351,127l-95,95-95-95A24,24,0,0,0,127,161l95,95-95,95A24,24,0,1,0,161,385l95-95,95,95A24,24,0,0,0,385,351Z"></path></svg>
              Kapat
            </button>
            <h4>{{ notify.title }}</h4>
            <div v-html="notify.content"></div>
          </template>
        </Modal>
      </div>
      <div class="notify-modal" v-if="user_bonus">
        <Modal :isVisible="user_bonus">
          <template slot="content">
            <h4>Bonus almak istermisiniz?</h4>
            <div class="row" style="margin-top: 20px; padding: 15px 0">
              <div class="col" style="width: 50% !important;">
                <router-link style="height: 40px; font-weight: bold;" :to="{ name : 'User', params:{ section: 'bonus' } }" class="button primary block">Evet </router-link>
              </div>
              <div class="col" style="width: 50% !important;">
                <a style="height: 40px; font-weight: bold;" href="javascript:;" class="button danger block" @click="hideBonus()">Hayır</a>
              </div>
            </div>
          </template>
        </Modal>
      </div>
    </div>
  </div>
</template>

<script>
  import Header from '@/components/Common/Header';
  import Footer from '@/components/Common/Footer';
  import DomainInfo from '@/components/Common/DomainInfo';
  import MobileBottom from '@/components/Common/MobileBottom';
  import MobilePanelLeft from '@/components/Common/Header/MobilePanelLeft';
  import MobilePanelRight from '@/components/Common/Header/MobilePanelRight';
  
  export default{
    name:'App',
    metaInfo () {
      return {
        title: this.$pageMeta(this.$route.meta.pageName + '.title'),
        meta: [
          { vmid: 'description', name: 'description', content: this.$pageMeta(this.$route.meta.pageName + '.description') },
          { vmid: 'keywords', name: 'keywords', content: this.$pageMeta(this.$route.meta.pageName + '.keywords') }
        ]
      }
    },
    data(){
      return{
        activePanel: '',
        isNotify: false,
        isBonus: false,
        isLoading: false,
      }
    },
    components:{
      Header,
      Footer,
      MobileBottom,
      MobilePanelLeft,
      MobilePanelRight,
      DomainInfo
    },
    created(){
      this.init();
      if(this.$route.params.section){
        this.$store.commit('setUserRouter', this.$route.params.section); // Check and set user router when starting page
      }
    },
    watch:{
      '$route.params.section': function (val) { // Watch and Set User Router from router
        if(this.$route.name != 'User'){
          this.$store.commit('setUserRouter', null);
        }else{
          if(val){
            this.$store.commit('setUserRouter', val);
          }
        }
      },
      user(){
        if(this.user){
          this.$store.dispatch('initUserBonus')
        }
      },
      notify(val){
        if(val){
          document.querySelector("#app").classList.add('lock');
        }else{
          document.querySelector("#app").classList.remove('lock');
        }
      },
      user_bonus(val){
        if(val){
          document.querySelector("#app").classList.add('lock');
        }else{
          document.querySelector("#app").classList.remove('lock');
        }
      },
    },
    computed:{
      BetSlip(){
        return this.$store.getters.getBetSlip;
      },
      user_bonus(){
        if(!_.isEmpty(this.$store.getters.getBonusReceivable) && this.$route.params.section != 'bonus') {
            return true
        }else{
          return false;
        }
      },
      routeLayout(){
        if(this.$route.name == 'Maintenance' || this.$route.name == 'NotFound'){
          return false
        }else{
          return true
        }
      },
      notify(){
        return this.$store.getters.getNotification;
      },
      user(){
        return this.$user();
      }
    },
    methods:{
      init(){
        this.isLoading = true;
        this.$store.dispatch('initClient')
        .then(response =>{

          this.isLoading = false;
          if(!_.isEmpty(this.$store.getters.getClientContent.livechat)){this.startLiveChat();}

          return response
        })
      },
      startLiveChat(){
          let liveChat = document.createElement('script');
          liveChat.type = 'text/javascript';
          liveChat.text = this.$store.getters.getClientContent.livechat;
          document.head.appendChild(liveChat);
      },
      hideBonus(){
        this.$store.dispatch('hideBonus');
      },
      closeNotify(key){
        this.$store.dispatch('closeNotify', key);
      }
    },
  }
</script>

<style>
  :root{
    --client-background: #000;
    --client-logo-width : 250px;
    --client-logo-m-width : 100px;
    --client-c : #fff;
    --client-c2 : #fff;
    --client-c3 : #ffe96f;
    --c : #303030;
    --c2 : #fff;
    --client-button-c : #fff;
    --client-button2-c : #000;
    --client-input-bg : #fff;
    --client-input-c : #000;
    --client-loader-c : #fff;
    --tab-c : #cd5c5c;
    --dropdown-c: #161e25;
    --scroll-color: #171717;
    --scroll-bg: #101010;


    --client-header: #101010;
    --client-header-menu: #101010;
    --client-header-top: #101010;
    --client-m-header: #101010;
    --client-m-header-guest: #101010;

    --client-m-pnl-c: #171717;
    --client-m-pnl-link-c: #171717;

    --client-auth-bg: #171717;
    --client-auth-input: #fff;
    --client-auth-input-c: #000;

    --alert: #171717;

    --client-user-box-content: #171717;

    --client-user-link-active: #171717;
    --client-panel-title: #171717;

    --client-user-message-box: #171717;
    --client-user-message-box-user: #171717;

    --client-promo-title-bg: #131313;
    --client-promo-menu-link: #171717;

    --client-slot-providers-bg: #000000;
    --client-slot-categories-bg: #171717;

    /* Elements */
    --client-modal: #171717;
    --client-panel: #1d1d1d;
    --client-selectbox: #171717;
    --client-selectbox-color: #fff;
    --client-selectbox-icon: #fff;
    --client-selectbox-button: #303030;
    --client-selectbox-button-color: #fff;
    --client-selectbox-close: #1d1d1d;
    --client-selectbox-close-color: #fff;
    --client-special-page-top: #1d1d1d;
    --client-daterangepicker: #444;
    --client-affiliate-content-items: #3d3d3d;
    --client-filter-panel-input: #4c4c4c;
    --client-table-item: #000;
    --client-filter-button: #171717;
    --client-user-mobile-nav-menu: #171717;
    --client-payment-bg: #171717;
    --client-user-pay-form: #171717;
    --client-casino-mobile-header: #000;
    --client-casino-landing-box-c: #171717;
    --client-casino-mobile-category-button: #171717;
    --client-slot-provider-link: #171717;

    --odd-btn: #585858;
    --odd-color: #ffe96f;
    --success-color: #6ce602;
    --danger-color: #e51d1d;
    --warning-color: #f3de53;
    --fav-color: #f8de00;
    --info-color: #00abff;
    --checkbox-input: #b0b0b0;
    --checkbox-input-focus: var(--c);
    --client-virtual-btn: #171717;
    
    --user-menu: #666666;
    --user-info: #444;
    --user-info-balance: #666666;
    --user-info-access: #303030;
    --user-mobile-header: #3d3d3d;
    --user-mobile-header-detail: #3d3d3d;
    --user-mobile-coupon-detail: #3d3d3d;
    --user-coupon-content-item: #464646;
    --user-coupon-item: #666666;
    --user-box-content: #3d3d3d;
    --user-box-content-input: #505050;
    --user-box-content-icon: #3d3d3d;
    --user-pay-header: #3d3d3d;
    
    --tel-input: #fff;
    --client-footer: #181818;
  }
</style>
